export function formatHHMM(ts: number): string {
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

// Uptime relativo curto para indicador de live: "45s" / "12m" / "1h 23m".
// startedAtMs vem em ms desde epoch (Date.parse no adapter).
export function formatUptime(startedAtMs: number, nowMs: number = Date.now()): string {
  const totalSec = Math.max(0, Math.floor((nowMs - startedAtMs) / 1000));
  if (totalSec < 60) return `${totalSec}s`;
  const totalMin = Math.floor(totalSec / 60);
  if (totalMin < 60) return `${totalMin}m`;
  const hours = Math.floor(totalMin / 60);
  const remMin = totalMin % 60;
  return `${hours}h ${remMin}m`;
}

// Restante de timeout decrementando, formato humano (#126):
//   45 → "45s"  ·  600 → "10m"  ·  587 → "9m 47s"
//   3600 → "1h"  ·  3660 → "1h 1m"  ·  86400 → "1d"
// Decrementa a granularidade conforme o relógio anda — segundos só aparecem
// na faixa < 1h pra não poluir badges longos (24h → "23h ...").
export function formatTimeoutRemaining(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  if (s < 60) return `${s}s`;
  if (s < 3600) {
    const m = Math.floor(s / 60);
    const remS = s % 60;
    return remS === 0 ? `${m}m` : `${m}m ${remS}s`;
  }
  if (s < 86400) {
    const h = Math.floor(s / 3600);
    const remM = Math.floor((s % 3600) / 60);
    return remM === 0 ? `${h}h` : `${h}h ${remM}m`;
  }
  const d = Math.floor(s / 86400);
  return `${d}d`;
}
